export default __webpack_public_path__ + "static/media/bi_cart.ad354258.svg";